import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren &
  ComponentStyling & {
    readonly highContrast?: boolean;
  };

export const Unit = ({
  children,
  className,
  highContrast = false,
  style,
}: P) => (
  <span
    className={cn(
      'pl-[0.5ch]',
      highContrast ? 'text-tiga-text-default' : 'text-tiga-text-lighter',
      className,
    )}
    style={style}
  >
    {children}
  </span>
);
